import { __decorate, __metadata, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { SpeJSplitProxy, SpeViewNSplitProxy, UiPxSplitModule } from '@wlp/ui-px-split';

let SplitService = class SplitService {
    constructor(speJSplitProxy, speViewNSplitProxy) {
        this.speJSplitProxy = speJSplitProxy;
        this.speViewNSplitProxy = speViewNSplitProxy;
    }
    approveSplitItem(aproveSplitPayment) {
        return this.speJSplitProxy.approveSplitItem(aproveSplitPayment);
    }
    cancelSplitItem(cancelSplitPayment) {
        return this.speJSplitProxy.cancelSplitItem(cancelSplitPayment);
    }
    reprocessSplitItem(reprocessSplitPayment) {
        return this.speJSplitProxy.reprocessSplitItem(reprocessSplitPayment);
    }
    getSplitLotsPaginatedWithFilter(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams) {
        return this.speViewNSplitProxy.getSplitLotsPaginatedWithFilter(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams);
    }
    findSplitByUuid(uuid, uuidAccountPayment, typeCode) {
        return this.speViewNSplitProxy.findSplitByUuid(uuid, uuidAccountPayment, typeCode);
    }
    sumStatusValues(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams) {
        return this.speViewNSplitProxy.sumStatusValues(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams);
    }
    resumeSplitDataByTypeCode(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams) {
        return this.speViewNSplitProxy.resumeSplitDataByTypeCode(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams);
    }
};
SplitService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeJSplitProxy,
        SpeViewNSplitProxy])
], SplitService);

var UiBsSplitModule_1;
let UiBsSplitModule = UiBsSplitModule_1 = class UiBsSplitModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsSplitModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiBsSplitModule = UiBsSplitModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql'],
            }),
            UiPxSplitModule
        ],
        providers: [
            SplitService
        ],
        exports: [RxReactiveFormsModule],
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsSplitModule])
], UiBsSplitModule);

export { SplitService, UiBsSplitModule };
//# sourceMappingURL=wlp-ui-bs-split.js.map
